export default __webpack_public_path__ + "static/media/Mark-3-Suit-Cycles-15.e410deef.jpg";